module.exports = __webpack_public_path__ + "static/media/IMG_1952-min.40c151e9.JPG";